"use client";
import React, {useCallback} from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import $http from "@/app/_api";
import {PayStatus} from "@/app/(pay)/types";
import styles from "./PayWaitingDialog.module.css";
import BigTips from "@/Master/BigTips";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import usePageLifecycle from "@/app/hooks/usePageLifecycle";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {ShopItem, QueryOrderResponse} from "@/app/_api/types/store";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import {EffectType, SRewardUIPresenter} from "@/app/_components/Coin/SRewardUIPresenter";
import PayUtil from "@/Core/Pay/PayUtil";

interface PayWaitingDialogProps extends SDialogProps {
    ks: string;
    pType: string;
    shopItem: ShopItem;
}

export const PayWaitingDialogFC: React.FC<PayWaitingDialogProps> = (props) => {
    const { fcKey, ks, pType,shopItem } = props;

    const {closeDialog} = useDialogMethods(fcKey);

    const onEnter = () => {
        handleConfirmation();
        // console.log('页面进入，可见');
        // 在页面进入时执行的逻辑，例如恢复动画、重新获取数据等
    };

    const onLeave = () => {
        // console.log('页面离开，不可见');
        // 在页面离开时执行的逻辑，例如暂停动画、保存状态等
    };


    useCallback(() => {
        usePageLifecycle(onEnter, onLeave);
    }, []);

    // 查询支付结果
    const queryPayResult = () => {
        return $http.Store.queryOrder({
            ks,
            ptype: pType
        });
    }

    // 用户点击确认按钮连续7次校验支付结果
    const confirmPayResult: () => void = async () => {
        let tasks = new Array(7).fill(queryPayResult);
        for (let result of tasks) {
            let responseData:QueryOrderResponse = await result();
            if (!responseData?.orderStatus){
                break;//跳出 用户下次点击后可继续查询。不关闭页面
            }
            if (responseData.orderStatus !== PayStatus.WAITING) {
                if (responseData.orderStatus == PayStatus.SUCCESS){
                    onRewardAni(shopItem,responseData);
                    console.log("支付结果已生成", responseData);
                    closeDialog();
                }else{
                    BigTips.showMsg(`支付结果 = ${PayUtil.getPayStatusName(responseData.orderStatus)}`);
                }
                closeDialog();
                break;
            }
        }
        hideForceLoading()
    }



    const onRewardAni = (item:ShopItem,data:QueryOrderResponse) => {
        SDialogManagerFC.openDialog(RewardDialogFC,{
            fcKey:SDialogManagerFC.getFCKey(RewardDialogFC),
            onClose:()=>{
                SRewardUIPresenter.Instance.PlayRewardAnimation(item.gc, item.sc, EffectType.FlyIcon)
            },
            gcCount:item.gc,
            scCount:item.sc,
        })
    }

    const handleConfirmation = () => {
        showForceLoading()
        confirmPayResult();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            title={
                <p style={{ marginBottom: ".4rem", fontSize: ".6rem", fontWeight: "bold" }}>
                    Payment is being processed..
                </p>
            }
            buttons={[
                {
                    label: "Confirmation",
                    onClick: handleConfirmation,
                    style: "greenBtn",
                },
            ]}
        >
            <section className={styles.content}>
                <section className={styles.payment_list_wrapper}>
                    After the payment is completed, please click the <span style={{color: 'var(--mark-text-color)'}}>Confirmation</span> button. and the system will automatically query the payment results.
                </section>
            </section>
        </SDialogFC>
    );
};